<template>
    <div>
        <Breadcrumbs main="Admin" submain="Resources / Asset Type" :title="details.name" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6">
                                    <h6>Asset Type: {{ details.name }}</h6>
                                    <div class="row mt-4">
                                        <div class="col-md-8">
                                            <div class="form-group">
                                                <input class="form-control" type="text" placeholder="Enter checklist item" v-model="feature">
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <button class="btn btn-primary" @click="addFeature">Add</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="row mt-4">
                                        <div class="col-md-12">
                                            <h6>Checklist Items</h6>
                                            <ul class="list-group mt-3">
                                                <li style="margin-bottom: 12px;" v-for="(feat, index) in details.feature" :key="index">
                                                    <span>{{ index + 1 }}.</span> {{ feat.feature }}
                                                    <span class="float-right ml-2" @click="removeFeature(feat.id)" v-b-modal.modal-center>❌</span>
                                                </li> 
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->

        <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
            <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this feature?</div>
        </b-modal>
    </div>
</template>
    
<script>
    import Swal from 'sweetalert2/dist/sweetalert2.js';
    import 'sweetalert2/src/sweetalert2.scss';
    import { mapState } from 'vuex';
    import { myHost } from '../../../_helpers/host';
    import loader from '../loader/loader.vue';
    
    export default {
        components: {
            loader
        },
    
        data() {
            return {
                feature: null,
                delete_id: null
            };
        },
    
        computed: {
            ...mapState({
                details: state => state.asset.typeDetail,
                loading: state => state.asset.assetTypeLoading,
                error: state => state.asset.assetTypeError
            })
        },
    
        mounted() {
            this.$store.dispatch("asset/fetchAssetTypeDetail", this.$route.params.id)
        },
    
        methods: {
            addFeature() {
                this.$store.dispatch("asset/addFeature", {
                    type_id: this.$route.params.id,
                    feature: this.feature
                }).then(() => {
                    this.feature = null;
                });
            },

            removeFeature(index) {
                this.delete_id = index;
                this.$bvModal.show('modal-center');
            },

            handleDeleteOk() {
                this.$store.dispatch("asset/removeFeature", {
                    type_id: this.$route.params.id,
                    delete_id: this.delete_id
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.delete_id = null
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
    
                this.$nextTick(() => {
                    this.$bvModal.hide('modal-center')
                })
            }
        }
    };
</script>
    